import { render, staticRenderFns } from "./covt.vue?vue&type=template&id=4999c59f&scoped=true"
import script from "./covt.vue?vue&type=script&lang=js"
export * from "./covt.vue?vue&type=script&lang=js"
import style0 from "./covt.vue?vue&type=style&index=0&id=4999c59f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0__css-load_84097bf1da1fe89cf094ff7a2cbe4d08/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4999c59f",
  null
  
)

export default component.exports